namespace GeniuzPOS.LogManage {
    export class LogApiPathColumns {
        static columnsKey = 'LogManage.LogApiPath';
    }
}
